import { render, staticRenderFns } from "./PricingHeader.vue?vue&type=template&id=916a242c&"
import script from "./PricingHeader.vue?vue&type=script&lang=js&"
export * from "./PricingHeader.vue?vue&type=script&lang=js&"
import style0 from "./PricingHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports